import { useReducer } from 'react';
var toggleReducer = function (state, nextValue) { return (typeof nextValue === 'boolean' ? nextValue : !state); };
var useToggle = function (initialValue) {
    return useReducer(toggleReducer, initialValue);
};
export default useToggle;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useToggle.js
// module id = VrMf
// module chunks = 0